function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.984,14H1.556A1.538,1.538,0,0,1,0,12.441Q0,7,0,1.555A1.541,1.541,0,0,1,1.547,0q4.6,0,9.192,0A.331.331,0,0,1,11,.1c.965.971,1.935,1.936,2.9,2.908a.378.378,0,0,1,.1.239Q14,7.86,14,12.471A1.547,1.547,0,0,1,12.474,14ZM8.841,2.468h-5.8a.98.98,0,0,0-.98.98V4.58a.98.98,0,0,0,.98.98h5.8a.98.98,0,0,0,.98-.98V3.448A.98.98,0,0,0,8.841,2.468ZM7,11.618A2.01,2.01,0,1,0,4.99,9.573,2.011,2.011,0,0,0,7,11.618Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/save.751025a9.svg";
export { SvgComponent as ReactComponent };